import React, { Component } from 'react'
import './styles.css'
import Dropzone from 'react-dropzone'
import PropTypes from 'prop-types'

class UploadZone extends Component {
  constructor (props) {
    super(props)
    this.state = {
      dragOver: false
    }
  }

  onDrop = (files) => {
    this.setState({
      dragOver: false
    })
    this.props.onDrop(files)
  }

  onDragEnter = () => {
    this.setState({
      dragOver: true
    })
  }

  onDragLeave = () => {
    this.setState({
      dragOver: false
    })
  }

  render () {
    return (
      <div className="UploadZone">
        <div className="UploadZone-Layer" style={{ opacity: (this.state.dragOver ? '1' : '0') }}>
          <p className="UploadZone-Drop">Just drag your photo into<br/> this area</p>
        </div>
        <Dropzone ref={this.props.dropzoneRef} accept={'image/*'} multiple={true}
                  onDrop={this.onDrop} onDragEnter={this.onDragEnter}
                  onDragLeave={this.onDragLeave} noClick={true} disabled={this.props.disabled}>
          {({ getRootProps, getInputProps }) => (
            <div {...getRootProps()}>
              <input {...getInputProps()} />
              {this.props.children}
            </div>
          )}
        </Dropzone>
      </div>
    )
  }
}

UploadZone.propTypes = {
  onDrop: PropTypes.func.isRequired,
  dropzoneRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  disabled: PropTypes.bool,
}

export default UploadZone
